export function YourHackBadge() {
  return (
    <a
      href="https://yourhack.ai"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex opacity-75 transition-opacity hover:opacity-100 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      aria-label="Listed on yourhack.ai"
      data-testid="yourhack-badge"
    >
      <img
        src="https://yourhack.ai/badge/yourhack.svg"
        alt="Listed on yourhack.ai"
        width="180"
        height="20"
        loading="lazy"
      />
    </a>
  );
}